// libraries
import clsx from 'clsx'

// components
import Image, { ImageProps } from '/react4xp/components/Image'

// types
interface MacroImageProps {
    className?: string
    image?: ImageProps
    caption?: string
}

// css
import './index.scss'

export default function MacroImage({
    className,
    image,
    caption
}: MacroImageProps) {
    return (
        <figure className={clsx(
            'image-macro-component',
            className
        )}>

            {image?.src && (
                <Image
                    src={image?.src} // 1400 x auto
                    srcLarge={image?.srcLarge} // 1100 x auto
                    srcMedium={image?.srcMedium} // 800 x auto
                    srcSmall={image?.srcSmall} // 500 x auto
                    alt={image?.alt || ''}
                    sizes='(max-width: 575px) 100vw, 1312px'
                    lazyLoad
                />
            )}

            {caption && (
                <figcaption className='image-macro-component__caption body-small'>
                    {caption}
                </figcaption>
            )}

        </figure>
    )
}